import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateValidationFolders } from '@api/configurationTemplates';

import { validationIdToOptionsFormatter } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_VALIDATION_RULES_FOLDERS } from '@constants/queryKeys';

export interface IUseQueryTemplatesValidationValidationRulesFoldersReturn {
	validationRulesFolders: TSelectOption[];
	isLoadingValidationRulesFolders: boolean;
}

export const useQueryTemplatesValidationValidationRulesFolders = (
): IUseQueryTemplatesValidationValidationRulesFoldersReturn => {
	const {
		data,
		isFetching,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_VALIDATION_RULES_FOLDERS],
		queryFn: getConfigurationTemplateValidationFolders,
		select: validationIdToOptionsFormatter,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		validationRulesFolders: data || [],
		isLoadingValidationRulesFolders: isFetching || isInitialLoading,
	};
};

export default useQueryTemplatesValidationValidationRulesFolders;
